import { ServiceRequestRepository } from './ServiceRequestClientUnitRepository'
import ServiceRequestModel from '../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceRequesClientUnitController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequesClientUnitController', new ServiceRequesClientUnitController())
  }

  async loadCards (consumerUnit) {
    return await ServiceRequestRepository.loadCards(consumerUnit)
  }

  async loadCadClient () {
    return await ServiceRequestRepository.loadCadClient()
  }

  async updateConsumerUnit (consumerUnit) {
    await ServiceRequestRepository.updateConsumerUnit(consumerUnit)
  }

  async saveCardClient (dadosForm, isPesrson) {
    return await ServiceRequestRepository.saveCardClient(dadosForm, isPesrson)
  }

  async resolveCardClient (dadosForm, isPesrson) {
    return await ServiceRequestRepository.resolveCardClient(dadosForm, isPesrson)
  }

  async loadClientUnitCard (consumerUnit) {
    return await ServiceRequestRepository.loadClientUnitCard(consumerUnit)
  }
}
